import { message } from "antd";
import { api } from "../apiCore";

interface getAccountingBalanceParams {
  year: number;
  applicationBankId: number;
}

export const financeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Получение данных БО из внешних источников
    getAccountingBalance: builder.query<any, getAccountingBalanceParams>({
      query: ({ year, applicationBankId }) => {
        return {
          url: `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/search-accounting-balance?year=${year}`,
          method: "GET",
        };
      },
      async onQueryStarted({ year }, { queryFulfilled }) {
        try {
          await queryFulfilled;
          message.success(`Данные за ${year} год успешно загружены`);
        } catch {
          message.error(`Не удалось найти данные за ${year} год`);
        }
      },
    }),
    // Сохранение данных БО
    updateAccountingBalance: builder.mutation<
      any,
      { applicationBankId: number; data: any }
    >({
      query: ({ applicationBankId, data }) => {
        return {
          url: `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/update-accounting-balance`,
          method: "PUT",
          body: data,
        };
      },
      async onQueryStarted(year, { queryFulfilled }) {
        try {
          await queryFulfilled;
          message.success(`Данные успешно сохранены`);
        } catch {
          message.error(`Не удалось сохранить данные`);
        }
      },
    }),
  }),
});

export const {
  useLazyGetAccountingBalanceQuery,
  useUpdateAccountingBalanceMutation,
} = financeApi;
